module.exports = __webpack_public_path__ + "static/img/img2.1361c0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/img2.png
// module id = gvl9
// module chunks = 8